import { useEffect, useState } from "react";
import Loading from "../../../components/Loading";
import { colors } from "../../../assets/colors";

import { ProjectsTypes } from "../../../interfaces/ProjectsTypes";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { getHistory } from "../../../api/history";
import {
  ActionTypeTextEnum,
  HistoryTypes,
} from "../../../interfaces/HistoryTypes";
import { formatDateTimePtBr } from "../../../utils/dateUtils";

interface Props {
  currentProject: ProjectsTypes;
}

export default function HistoryTab({ currentProject }: Props) {
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState<HistoryTypes[]>([]);

  useEffect(() => {
    setLoading(true);
    fetchHistory();
  }, []);

  const fetchHistory = () => {
    getHistory(currentProject.project_id)
      .then((response: any) => {
        setHistory(response);
        console.log(response);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      {loading && (
        <div style={styles.content}>
          <Loading />
        </div>
      )}

      {!loading && (
        <Paper sx={{ width: "100%", marginTop: 6 }}>
          <TableContainer sx={{ maxHeight: 550 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow sx={{ backgroundColor: colors.background }}>
                  <TableCell
                    align="center"
                    sx={{ backgroundColor: colors.background }}
                  >
                    Ação
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ backgroundColor: colors.background }}
                  >
                    O que
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ backgroundColor: colors.background }}
                  >
                    Usuário
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ backgroundColor: colors.background }}
                  >
                    Data
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {history &&
                  history.length > 0 &&
                  history
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((history: HistoryTypes) => (
                      <TableRow key={history.id}>
                        <TableCell align="center">
                          {ActionTypeTextEnum[history.action_type]}
                        </TableCell>
                        <TableCell align="center">
                          {history.action_name}
                        </TableCell>
                        <TableCell align="center">
                          {history.user_name}
                        </TableCell>
                        <TableCell align="center">
                          {formatDateTimePtBr(new Date(history.date))}
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={history.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}
    </>
  );
}
const styles: any = {
  content: {
    backgroundColor: colors.white,
    marginTop: 50,
    marginLeft: 12,
    marginRight: 12,
  },

  title: {
    fontSize: 18,
    fontWeight: 600,
    color: "#1A1A1AFF",
    marginTop: 6,
  },
};
